import $ from 'jquery';

import TitleManager from '../../utils/TitleManager';
import { getLogoForCurrentBrand } from 'arbitrip-common/client/utils/dynamicBrandAssets';
import { isElalCompany, isIsracardCompany } from '@/utils/isCompany';
import ElalLoader from '@/img/elal-loader.gif';

/**
 * Created by MrJossef on 3/28/16.
 */
import React from 'react';
import createClass from 'create-react-class';

import { withTranslation } from 'react-i18next';
import moment from 'moment';
import DocumentTitle from '../general/DocumentTitle.react';

const holidays = {
	ROSH_HASHANA: 'rosh',
	XMAS: 'xmas',
};

const _Holidays = {
	[holidays.ROSH_HASHANA]: {
		from: 'Sep 24',
		to: 'Oct 4',
	},
	[holidays.XMAS]: {
		from: 'Dec 17',
		to: 'Dec 31',
	},
};

function getHoliday() {
	// holiday logic here..
	let NOW = moment();
	for (let holiday in _Holidays) {
		let from = moment(_Holidays[holiday].from, 'MMM D'),
			to = moment(_Holidays[holiday].to, 'MMM D');
		if (NOW.isAfter(from) && NOW.isBefore(to)) return holiday;
	}
}

let _lastRand = -1;
let _interval;
const _holiday = getHoliday();

const LoadingComponent = createClass({
	displayName: 'LoadingComponent',

	getInitialState() {
		// Initialize messages in component where we have access to translation function
		const { t } = this.props;
		this._messages = Object.values(t('LoadingMessages'));

		// Handle holiday messages
		if (_holiday) {
			this.setHolidayCustom(_holiday);
		}

		return {};
	},

	setHolidayCustom(holiday) {
		switch (holiday) {
			case holidays.ROSH_HASHANA:
				this._messages.splice(2, 0, 'Shana Tova!<br/>From your friends at Arbitrip');
				break;

			case holidays.XMAS:
				this._messages.splice(2, 0, 'Happy Holidays!<br/>From your friends at Arbitrip');
				break;

			default: // Do nothing
		}
	},

	randomMessage() {
		let _rand = Math.floor(Math.random() * this._messages.length);
		while (_rand === _lastRand) {
			_rand = Math.floor(Math.random() * this._messages.length);
		}
		if (_lastRand === -1 && _holiday) {
			_rand = 2;
		}
		_lastRand = _rand;
		return this._messages[_rand];
	},

	animateMessages: function () {
		const $msg = document.querySelector('#loading-message .message');
		setTimeout(() => {
			window.Velocity($msg, { opacity: 0.01 }, { duration: 1 }).then(() => {
				$msg.innerHTML = this.randomMessage();
				window.Velocity($msg, { opacity: 1 }, { duration: 500 });
				//start the interval
				_interval = setInterval(() => {
					window.Velocity($msg, { opacity: 0.01 }, { duration: 500 }).then(() => {
						$msg.innerHTML = this.randomMessage();
						window.Velocity($msg, { opacity: 1 }, { duration: 500 });
					});
				}, 6500);
			});
		}, 100);
	},

	// Add change listeners to stores
	componentDidMount: function () {
		if (this.props.pending) {
			this.animateMessages();
		}
	},

	componentDidUpdate: function (prevProps) {
		if (!prevProps.pending && this.props.pending) {
			this.animateMessages();
		} else if (prevProps.pending && !this.props.pending) {
			if (_interval) {
				clearInterval(_interval);
			}
		}
	},

	componentWillUnmount: function () {
		clearInterval(_interval);
	},

	getHolidayMask: function (holiday) {
		switch (holiday) {
			case holidays.ROSH_HASHANA:
				return [
					<img key="a" src="/img/apple.png" alt="Shana Tova" className="apple-leaf" />,
					// <img key='h' src="/img/honey.png" alt="Shana Tova" className="honey" />,
				];
			case holidays.XMAS:
				return <img src="/img/santacornerhat.png" alt="Happy Holidays" className="santa-hat" />;
			default:
				return null;
		}
	},

	render: function () {
		const logo = getLogoForCurrentBrand();
		const isElal = isElalCompany();
		const gifLoaderEl = <img src={ElalLoader} className="loader-gif" />;
		const { t } = this.props;
		const title = TitleManager.buildTitleEndsWith(t('FindingBestHotels'), false);

		if (this.props.pending) {
			const HOLIDAY_MASK = this.getHolidayMask(_holiday);
			if (_holiday) {
				console.log(_holiday, HOLIDAY_MASK);
			}
			const rosh = _holiday === holidays.ROSH_HASHANA;
			return (
				<DocumentTitle title={title}>
					<div className="loading" id="app_loader">
						<div className="logo-container">
							{isElal
								? gifLoaderEl
								: <span className={`logo hvr-bob${rosh ? ' rosh' : ''}`}></span>
							}
							{!isElal && HOLIDAY_MASK}
						</div>
						<div className="messages" id="loading-message">
							<p className="message"></p>
						</div>
					</div>
				</DocumentTitle>
			);
		} else {
			return (
				<DocumentTitle title={TitleManager.defaults()}>
					<div className="loading" id="init_loader">
						<div className="messages" id="loading-message">
							<p className="message">
								{isElal
									? gifLoaderEl
									: <i className="fa fa-spin fa-spinner" title={t('Loading')} />
								}
							</p>
						</div>
						<div className="banner">
							{!isIsracardCompany() && <img src={logo} alt="" className="logo" />}
						</div>
					</div>
				</DocumentTitle>
			);
		}
	},
});

export default withTranslation()(LoadingComponent);
